import { FGTextAreaInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import * as Yup from "yup";

import { ColorApi, ColorDto, ColorTranslationDto } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import {
  FGMultiTranslate,
  FGSRSHCheckboxInput,
  SmallFormGenerator,
} from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IColorDetailPageProps {
  colorId: number;
  editMode: boolean;
}

export const ColorDetailPage: React.FunctionComponent<IColorDetailPageProps> = ({
  colorId,
  editMode,
}) => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(ColorApi);
  const { languages } = useGlobalData();

  const { data, loading, saveItem, saving, deleteItem, deleting } = useCrudApi(
    {
      getApiFn: (id = colorId) =>
        id > 0
          ? api.getColor(id)
          : new ColorDto({
              colorTranslations: [
                ...languages.map(
                  (l) =>
                    new ColorTranslationDto({
                      languageId: l.languageId,
                    })
                ),
              ],
            }).toJSON(),
      saveApiFn: (d: ColorDto) => api.saveColor(d),
      onSavedRoute: (d) => `${ERoutes.color}/${d.colorId}/detail/edit`,
      deleteApiFn: (d) => api.deleteColor(d.colorId),
      onDeletedRoute: (d) => `${ERoutes.color}`,
    },
    [colorId]
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      code: Yup.string().nullable().required(t(ETLCodes.Required)),
      colorTranslations: Yup.array().of(
        Yup.object().shape({
          text: Yup.string().nullable().required(t(ETLCodes.Required)),
        })
      ),
    });
  }, [t]);

  return (
    data && (
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={editMode}
        loading={loading}
        onCancel={() => history.push(ERoutes.color)}
        saving={saving}
        deleting={deleting}
        showDeleteButton={colorId > 0}
        onDelete={deleteItem}
        validationSchema={FormSchema}
      >
        <FieldGroup>
          <FGMultiTranslate
            label={ETLCodes.Name}
            translationsArrayField="colorTranslations"
            translationField="text"
            translationDto={ColorTranslationDto}
          />
          <FGTextInput name="code" label={t(ETLCodes.Code)} />
          <FGSRSHCheckboxInput name="isMerle" label={t(ETLCodes.IsMerle)} />
          <FGSRSHCheckboxInput name="official" label={t(ETLCodes.Official)} />
          <FGTextAreaInput name="remark" label={t(ETLCodes.Remark)} />
        </FieldGroup>
      </SmallFormGenerator>
    )
  );
};
